module.exports = __webpack_public_path__ + "img/gsjj.47a2ab78.jpg";